<script setup>
import { onMounted } from 'vue'
import stripslashes, { nl2br } from '@/Shared/helper.js'
import Overlay from '@/Shared/Overlay'
import ButtonClose from '@/Shared/Buttons/ButtonClose'
import Icon from '@/Shared/Icons/Icon'

const props = defineProps({
  overlay: String,
  category: String,
  func: Function,
  params: Object,
  pref: Object,
})

const emit = defineEmits(['close'])

const clickAction = () => {
  emit('close')
  // props.func()
}

onMounted(() => {
  // console.log(getBrandName('chaco'))
  // console.log(props.params.contactName)
  // console.log(props.params.contactFurigana)
  // console.log(props.params)
  // console.log(props.pref)
})
</script>

<template>
  <div class="contact-modal modal-container center-container xl:w-main-xl 2xl:w-main-2xl xl:!left-auto">
    <Overlay v-if="props.overlay !== 'false'" @click="emit('close')" />
    <div class="bg-white rounded-[20px] xs:w-[80vw] relative z-20 max-w-[600px] md:min-w-[600px] overflow-hidden">
      <ButtonClose class="absolute z-20 top-0 right-0 p-[22px] origin-top-right scale-[1] sm:scale-[1.2]" @click="emit('close')" />

      <div class="max-h-[80dvh] overflow-y-auto">
        <div class="p-[30px] sm:p-[40px] md:p-[50px]">
          <template v-if="category === 'form'">
            <h2 class="text-[18px] xs:text-[20px] sm:text-[22px] mb-[10px] sm:mb-[20px] font-bold leading-[1.6]">SABBATICAL 修理のご案内</h2>
            <p class="mb-[20px] sm:mb-[30px] leading-[1.6]">SABBATICAL（サバティカル）では、テント及び関連商品の修理については、お客様へのサービス向上の目的で、株式会社ゼインアーツの協力を得て共同運営しております。</p>
            <p class="mb-[20px] sm:mb-[30px]  leading-[1.6]">製品やパーツの廃盤により、資材の入手が困難な場合や製品の状態によっては、修理ができない場合もございますので予めご了承ください。修理については、状況・程度により金額が異なりますので予めご了承くださいませ。</p>
            <p class="mb-[20px] sm:mb-[30px]  leading-[1.6]">修理品をお預けの際は、製品を乾燥させた状態で汚れを取ってからお預けください。水気や汚れのあるものは修理作業の妨げになります。修理前に一度それらを取り除く作業を行った場合には、修理品の納期・修理価格等に影響がでてしまい、結果的にお客様へのご負担が増える場合がございます。ご理解の程、宜しくお願い致します。</p>
            <p class="mb-[20px] sm:mb-[30px]  leading-[1.6]">修理依頼は下記の株式会社ゼインアーツ「製品の修理依頼」ページより、直接お問い合わせくださいませ。</p>
            <p class="mb-[20px] sm:mb-[30px]  leading-[1.6]">※今後の修理についてのやりとりにつきましては、 直接、株式会社ゼインアーツが対応させていただきます。</p>
            <p class="mb-[20px] sm:mb-[30px]  leading-[1.6]"><a href="https://zanearts.com/after_service/" target="_blank">https://zanearts.com/after_service/</a></p>
            <button class="submitBtn" type="button" @click="emit('close')">閉じる<Icon type="arrow" /></button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
